import { useState, useEffect } from "react";
import baseUrl from "../../configs/baseurl";
import MUIDataTable from "mui-datatables";
import axios from "axios";
//mui-datatables theme
import zhCN from "date-fns/locale/zh-CN";
import "./linkstable.scss";
//editor
import Preview from "../../img/preview_black_24dp.svg";
import Edit from "../../img/edit_black_24dp.svg";
import Delete from "../../img/delete_black_24dp.svg";

const LinksTable = () => {
  // hooks
  const [links, setLinks] = useState([]);
  // axios
  const endpoint = `${baseUrl}/datasql/getlinks`;

  const getData = async () => {
    await axios.get(endpoint).then((response) => {
      const data = response.data;
      console.log(data);
      setLinks(data);
    });
  };

  useEffect(() => {
    getData();
  }, []);

  // columns
  const columns = [
    //id 1
    // {
    //   name: "id",
    //   lable: "ID",
    // },
    //key 2
    {
      name: "from",
      lable: "起点",
      options: {
        display: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowIndex = tableMeta.rowIndex;
          let textAlign = "center";
          return <div style={{ textAlign }}>{value}</div>;
        },
        //--
      },
    },
    //text 3
    {
      name: "to",
      lable: "终点",
    },
    //loc 4
    {
      name: "text",
      lable: "文字",
      options: {
        display: false,
        filter: false,
      },
    },
    //figure 5
    {
      name: "fromspot",
      lable: "起端点",
    },
    //color 6
    {
      name: "tospot",
      lable: "结端点",
    },
    //fill 7
    {
      name: "color",
      lable: "颜色",
    },
    //size 8
    {
      name: "thickness",
      lable: "粗度",
      options: {
        display: false,
      },
    },
    //thickness 9
    {
      name: "dash",
      lable: "虚线",
      options: {
        display: false,
      },
    },
    //group 10
    {
      name: "dr",
      lable: "箭头",
      options: {
        display: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowIndex = tableMeta.rowIndex;
          let textAlign = "center";

          return <div style={{ textAlign }}>{value}</div>;
        },
      },
    },
    //isgroup 11
    {
      name: "routing",
      lable: "连线样式",
      options: {
        display: true,
      },
    },

    //image 13
    {
      name: "image",
      lable: "图片",
      options: {
        print: false,
      },
      //   options:{
      //     customBodyRender: () => <div><img src={nodes.image} className="image" alt='test' /></div>
      // }
    },
    //action 14
    {
      name: "ACTION",
      lable: "设定",
      options: {
        filter: false,
        sort: false,
        empty: true,
        print: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowData = tableMeta.rowData;
          return (
            <div className="tableCell">
              <ul>
                <li class="icon-table" id="preview">
                  <img src={Preview} alt="" />
                </li>
                <li class="icon-table edit" id="edit">
                  <img src={Edit} alt="" />
                </li>
                <li
                  class="icon-table delete"
                  id="delete"
                  // onClick={() => deleteContact(user.id)}
                >
                  <img src={Delete} alt="" />
                </li>
              </ul>
            </div>
          );
        },
      },
    },
    //status 15
    {
      name: "status",
      lable: "状态",
      options: {
        filter: false,
        empty: true,
        print: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          //   console.log("deletedstatus", value);
          //   const rowData = tableMeta.rowData;
          //   const status = rowData[14];
          //   console.log("deletedstatus2", status);
          //   const buttonLabel = value === 'Active' ? 'Deactivate' : 'Activate';
          return (
            <div className="tableCell status">
              <ul>
                <li
                  class={
                    value === "Active"
                      ? "icon-table-deleted"
                      : "icon-table-deleted active"
                  }
                  id="deleted"
                  // onClick={() => deleteContact(user.id)}
                ></li>
              </ul>
            </div>
          );
        },
      },
    },
  ];

  // render data
  const options = {
    textLabels: {
      body: {
        noMatch: "没有找到匹配项",
        toolTip: "排序",
      },
      pagination: {
        next: "下一页",
        previous: "上一页",
        rowsPerPage: "每页显示行数:",
        displayRows: " 总行数",
      },
      toolbar: {
        search: "搜索",
        downloadCsv: "下载 CSV",
        print: "打印",
        viewColumns: "显示列",
        filterTable: "筛选表格",
      },
      filter: {
        all: "全部",
        title: "筛选",
        reset: "重置",
      },
      viewColumns: {
        title: "显示列",
        titleAria: "选择要显示的列",
      },
      selectedRows: {
        text: "行 已选择",
        delete: "删除",
        deleteAria: "删除所选行",
      },
    },

    //--------------
    rows: {
      height: "15px",
    },
    page: 0,
    rowsPerPage: 6,
    rowsPerPageOptions: [5, 6],
    columnTitle: (column) => column.label,
  };

  return (
    <div className="datatable">
      <MUIDataTable
        title={"Linksdatas"}
        columns={columns}
        data={links}
        options={options}
        language={zhCN}
      />
    </div>
  );
};

export default LinksTable;
